import { apiUrl2 } from '../../settings'

export const counsellorBonusListUrl = () => {
  return apiUrl2 + '/CounsellorBonusList'
}